import { attachInvocaScript } from '@ehi/utils/lib/invoca/loadInvocaSolutions';
import { Script } from 'gatsby';
import { useEffect, useState } from 'react';

const ThirdPartyResources = () => {
    const [launchReady, setLaunchReady] = useState(false);

    useEffect(() => {
        attachInvocaScript({
            tagId: `1566/${process.env.GATSBY_INVOCA_TAG_ID}`,
            apexDomain: 'ehealthinsurance.com',
            // onInit fires synchronously before the script tag is inserted, setting window.InvocaTagId
            onInit: () => setLaunchReady(true),
        }).catch(console.error);
    }, []);

    return (
        <>
            {launchReady && <Script src={process.env.GATSBY_//assets.adobedtm.com/b21848b216eb/78836cc116ec/launch-ef4be89f32be.min.js} async />}
            {process.env.GATSBY_EH_ENV === 'prod' && (
                <Script
                    src="https://js.sentry-cdn.com/d5123a0c141510bfa6ac69244570951d.min.js"
                    crossOrigin="anonymous"
                    async
                />
            )}
        </>
    );
};

export default ThirdPartyResources;
